
export const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
  
  export const tokenLifeCheck = (token: string):boolean => {
    const check: boolean = JSON.parse(atob(token.split(".")[1])).exp < Math.floor(Date.now() / 1000);
    return check;
  }
  
  export const decodeToken = (token: string) => {
    try {
      const base64Url = atob(token);
      const base64 = base64Url.replace(/\s/g, "").replace(/'/g, '"');
      return JSON.parse(base64);
    } catch (e) {
      return null;
    }
  }
  
export const navbarScroll = () => {
  let lastScrollTop = 0;
  window.addEventListener('scroll', function () {
    const navbar = document.getElementById('navbar');
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (navbar) {
      if (scrollTop > lastScrollTop) {
        navbar.classList.add('shadow');
        navbar.style.transform = 'translateY(-100%)';
        navbar.style.transition = 'transform 0.3s ease-in-out';
      } else {
        if (window.scrollY === 0) {
          navbar.classList.remove('shadow');
        }
        navbar.style.transform = 'translateY(0)';
        navbar.style.transition = 'transform 0.3s ease-in-out';
      }
      lastScrollTop = scrollTop;
    }
  });
}